import React from "react";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import { useEffect,useState } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api";
import ESPCustomerFeedback from "../../components/EServicePartnerServiceRequests/ESPCustomerFeedback";
import { getESPUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import { ArrowLeft} from "react-feather";

export default function CustomerFeedbackContainer(props)
{

    const [fromDate, setfromDate] = useState(props.fromDate);
    const [toDate, settoDate] = useState(props.toDate);    
    const [responseType, setResponseType] = useState(props.responseType);

    let data=[
        {
        "service_id": 202469,
        "service_name": "Shop Act Intimation Support Service",
        "customer_details": {
        "name": "Monu Tamshete",
        "email": "poojatamshete1031@mailinator.com",
        "contact_number": "8830358425"
        },
        "facilitator_name": "Vikrant Wadekar",
        "feedback_given": [
        {
        "que": "How would you rate your overall experience with our service partner?* ",
        "ans": 2
        },
        {
        "que": "What can we do to improve our service?*",
        "ans": "Timely Delivery"
        },
        {
        "que": "What can we do to improve our service?*",
        "ans": "Quick Response"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Quick Response"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Cost-effective"
        }
        ]
        },
        {
        "service_id": 202724,
        "service_name": "GST Registration Service",
        "customer_details": {
        "name": "Pooja Tamshete",
        "email": "poojatamshete014@mailinator.com",
        "contact_number": "8830358425"
        },
        "facilitator_name": "Vikrant Wadekar",
        "feedback_given": [
        {
        "que": "How would you rate your overall experience with our service partner?* ",
        "ans": 2
        },
        {
        "que": "What can we do to improve our service?*",
        "ans": "Timely Delivery"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Quick Response"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Cost-effective"
        }
        ]
        },
        {
        "service_id": 202721,
        "service_name": "GST Registration Service",
        "customer_details": {
        "name": "Pooja Tamshete",
        "email": "poojatamshete011@mailinator.com",
        "contact_number": "8830358425"
        },
        "facilitator_name": "Vikrant Wadekar",
        "feedback_given": [
        {
        "que": "How would you rate your overall experience with our service partner?* ",
        "ans": 4
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Timely Delivery"
        }
        ]
        },
        {
        "service_id": 202728,
        "service_name": "Shop Act Intimation Support Service",
        "customer_details": {
        "name": "Pooja Tamshete",
        "email": "poojatamshete018@mailinator.com",
        "contact_number": "8830358425"
        },
        "facilitator_name": "Vikrant Wadekar",
        "feedback_given": [
        {
        "que": "How would you rate your overall experience with our service partner?* ",
        "ans": 2
        },
        {
        "que": "What can we do to improve our service?*",
        "ans": "Timely Delivery"
        },
        {
        "que": "What can we do to improve our service?*",
        "ans": "Quick Response"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Quick Response"
        },
        {
        "que": "What did you like about our service?* ",
        "ans": "Cost-effective"
        }
        ]
        }
        ]
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [pages, setPages] = useState(0);
    const [currentPage, setcurrentPage] = useState(0);
	const [pageSize, setPageSize] = useState(10);
    const [tableInstance, setTableInstance] = useState(null);
    const [pageSizeOptions,setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const [customerFeedbackData, setCustomerFeedbackData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if(props.isForAdmin||props.isForBusinessAdmin)
        {
            getESPCustomerFeedbackData(tableInstance,true)
        }
        else
        {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else
            {
                getESPCustomerFeedbackData(tableInstance,true)
            }
        }
        
	},[]);

    /*useEffect(() => {
        if (!getESPUser()) {
			history.push("/service_partner/login");
		}
        else
        {
            getESPCustomerFeedbackData(tableInstance,true)
        }
	}, [selectedPageSizeOption]);

    const fetchESPCustomerFeedbackData = (instance, flag) => {
        if (!getESPUser()) {
			history.push("/service_partner/login");
		}
        else
        {
            getESPCustomerFeedbackData(instance, flag);
        }		
	};

    const changePage =(pageIndex) => {
        setcurrentPage(pageIndex);
      }*/

    const handleSearchInputChange = (e) => {
        const { value ,name} = e.target;
        setSearchTerm(value);
	};

    const handleSearchClick = async () => {
        getESPCustomerFeedbackData(tableInstance,true);
	};

    const getESPCustomerFeedbackData=(instance, flag = false)=>{

        /*if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
        const { page } = instance.state ?? { page: 0 };
        let currentPage=page;
        if (!flag &&isNaN(currentPage)) return;

        const pageSize =selectedPageSizeOption.value;
        
        if(flag || isNaN(currentPage))
        {
            currentPage=0;
        }

       let filterParameters = {
            //page_no:currentPage+1,
            //page_size:pageSize
        };

        if(searchTerm)
        {
            filterParameters.search_value=searchTerm;
        }*/  

        let filterParameters={}

        if(searchTerm)
        {
            filterParameters.search_value=searchTerm;
        }

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        if(props.isForAdmin)
        {
            filterParameters.EmailAddress = props.selectedExternalServicePartner.value;
        }

        setIsLoading(true);	
        const { tempServices } = api.getCustomerFeedbackList(filterParameters).then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                if(responseType)
                {
                    let filteredData=[];
                    let tempSPMerviceList= data.map((x) => 
                    {
                        if(x.csat==responseType)
                        {
                            filteredData.push(x);
                        }
                    });

                    setCustomerFeedbackData(filteredData);
                }
                else
                {
                    setCustomerFeedbackData(data);
                    //setcurrentPage(currentPage);
                    //setPages(data.total_pages);
                    //setPageSize(pageSize);
                }
                
            }
            else
            {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    return (
        <div className={`row row-container ${isLoading && "set-opacity"}`} >
			{isLoading && <Spinner className="center-screen" />}
            <div className="col-12">
				<div className="row">
					<div className="col-4" style={{paddingTop:"5px"}}>		
                        {props.isForBusinessAdmin?
                        (
                            <span style={{cursor:"pointer",color:"#76287C"}} 
                                onClick={()=>{props.onTabChanged("Service Requests")}}>
                                <ArrowLeft style={{marginRight:"10px",marginTop: "-2px"}}/>
                                {"Back"}
                            </span>
                        ):
                        (
                            ""
                        )}					
                    </div>
					<div className="col-4 conv-text-center">
                        {props.isForBusinessAdmin?(""):
                        (
                            <button className="con-btn-bordered-lg conv-pl50 conv-pr50 conv-font14 con-br0"
                                onClick={()=>{props.onTabChanged("Service Requests")}}>
                                Requests
						    </button>
                        )}						
						<button className="con-btn-filled con-btn-bordered-lg conv-font14 conv-text-decoration-u conv-pl15 conv-pr15 con-br0">
							Customer Feedback
						</button>
					</div>
					<div className="col-4">
						<button 
						className="con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
						onClick={()=>{handleSearchClick()}}>
							Search
						</button>
						<input
							type="text"
							className="conv-float-right form-control search-input"
							placeholder="Search"
							onChange={(e)=>{
                                handleSearchInputChange(e)}}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									handleSearchClick();
								}
							}}
							autoComplete={"false"}
							value={searchTerm}
							name="searchTerm"
						/>
					</div>
				</div>
			</div>
            <div className="col-12 service-partner spled-container conv-mt30">
                <ESPCustomerFeedback
                    data={customerFeedbackData}
                    //fetchESPCustomerFeedbackData={fetchESPCustomerFeedbackData}
                    pages={pages}
                    pageSize={pageSize}
                    page={currentPage}
                    //changePage={changePage}
                    pageSizeOptions={pageSizeOptions}
                    selectedPageSizeOption={selectedPageSizeOption}
                    onPageSizeOptionChange={(option) => {
                        setSelectedPageSizeOption(option);
                    }}
                />
            </div>
       </div>
    )
}